import React from 'react';
import useCloudEventsBaseParams from '../hooks/useCloudEventsBaseParams';

const withCloudEventBaseParams = ComponentClass => (props) => {
  const baseParams = useCloudEventsBaseParams();
  return <ComponentClass {...props} cloudEventsBaseParams={baseParams} />;
};

export default withCloudEventBaseParams;
